import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from "../Footer";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { SkeletonDashboard } from "../components/SkeletonLoader";

const MyDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [myCeredit, setMyCredit] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);

  const [state, setState] = useState({
    series: [
      {
        name: "Credits",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 250,
        type: "area",
        zoom: {
          enabled: false,
        },
        toolbar: {
          tools: {
            download: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      title: {
        text: "Credits",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    },
  });
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const baseUrl =
    window.CARLOCA_UPLOADS + "/users/";
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);

  const formatNumber = (num) => {
    if (num >= 10000000) {
      return (num / 10000000).toFixed(1) + "M";
    } else if (num >= 100000) {
      return (num / 100000).toFixed(1) + "L";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K";
    } else {
      return num.toString();
    }
  };

  const getMyDashboard = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/dashboard",
        {
          user_id: storedUserPreferences?.id,
        }
      );
      if (response?.data?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/credits",
        {
          user_id: storedUserPreferences?.id,
        }
      );
      setMyCredit(response?.data?.total_credit);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const fetchCredits = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/user/credits",
        {
          user_id: storedUserPreferences?.id,
        }
      );

      const myCredits = response?.data?.data;
      const categories = Object.keys(myCredits);
      const dataSeries = Object.values(myCredits);
      setState({
        series: [
          {
            name: "Credits",
            data: dataSeries,
          },
        ],
        options: {
          chart: {
            height: 250,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              tools: {
                download: false,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          title: {
            text: "Credits",
            align: "left",
          },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"],
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: categories,
          },
        },
      });
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  useEffect(() => {
    Promise.all([getMyDashboard(), fetchData(), fetchCredits()]).finally(() => setPageLoading(false));
  }, []);
  function backto() {
    window.history.back();
  }

  const dealerName =
    storedUserPreferences?.dealerName &&
      storedUserPreferences.dealerName !== "null"
      ? storedUserPreferences.dealerName
      : storedUserPreferences?.first_name;

  return (
    <>
      <Navbar />

      {/* ── Hero Header ─────────────────────────────────────────── */}
      <div className="dash-header">
        <div className="container">
          <div className="dash-header-inner">
            <div>
              <h2 className="dash-title">Welcome, {dealerName}!</h2>
              <p className="dash-subtitle-hero">Dealership overview &amp; activity</p>
            </div>
            <div className="dash-header-actions">
              <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-sm dash-btn-white">
                <i className="fa-solid fa-plus me-1"></i>Add Car
              </Link>
              <Link to="/dealer/my-inventory" className="cl-btn cl-btn-sm dash-btn-ghost">All Cars</Link>
              <Link to="/dealer/bulk-upload-cars" className="cl-btn cl-btn-sm dash-btn-ghost">
                <i className="fa-solid fa-upload me-1"></i>Bulk Upload
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ── Page Body ───────────────────────────────────────────── */}
      <div className="cl-page cl-page-no-top-pad">
        <div className="container">

          {/* Quick Nav */}
          <div className="dash-quick-nav">
            <Link to="/dealer/all-offers"><i className="fa-solid fa-tags"></i>Offers</Link>
            <Link to="/dealer/my-inventory"><i className="fa-solid fa-car"></i>My Cars</Link>
            <Link to="/dealer/my-inventory"><i className="fa-solid fa-warehouse"></i>Inventory</Link>
            <Link to="/dealer/unlock-requests"><i className="fa-solid fa-unlock"></i>Unlock Req.</Link>
            <Link to="/dealer/approved-unlock-request"><i className="fa-solid fa-check-circle"></i>Approved</Link>
            <Link to="/dealer/pending-unlocks"><i className="fa-solid fa-clock"></i>Pending</Link>
            <Link to="/edit/dealer/profile"><i className="fa-solid fa-user-pen"></i>Edit Profile</Link>
            <Link to="/buyplan"><i className="fa-solid fa-coins"></i>Buy Credits</Link>
          </div>

          {pageLoading ? (
            <SkeletonDashboard />
          ) : (
            <>
              {/* ===== SELLING ===== */}
              <div className="dash-section-label">
                <i className="fa-solid fa-tag"></i>Selling
              </div>
              <div className="row g-3 mb-4">
                {/* Total Cars */}
                <div className="col-6 col-sm-6 col-md-4">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#e0f7fa', color: '#00889c' }}>
                        <i className="fa fa-car"></i>
                      </div>
                    </div>
                    <div className="dash-stat-number">{data?.total_cars ?? 0}</div>
                    <div className="dash-stat-label">Total Cars</div>
                    <div className="dash-stat-action d-flex gap-2">
                      <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-primary cl-btn-sm flex-fill text-center">+ Add</Link>
                      <Link to="/dealer/my-inventory" className="cl-btn cl-btn-outline cl-btn-sm flex-fill text-center">View</Link>
                    </div>
                  </div>
                </div>

                {/* Published */}
                <div className="col-6 col-sm-6 col-md-4">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#d1fae5', color: '#10b981' }}>
                        <i className="fa fa-globe"></i>
                      </div>
                      <span className="dash-stat-badge" style={{ background: '#d1fae5', color: '#10b981' }}>Live</span>
                    </div>
                    <div className="dash-stat-number">{data?.publish ?? 0}</div>
                    <div className="dash-stat-label">Published</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/my-inventory" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>

                {/* Unpublished */}
                <div className="col-6 col-sm-6 col-md-4">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#fef3c7', color: '#f59e0b' }}>
                        <i className="fa fa-eye-slash"></i>
                      </div>
                      <span className="dash-stat-badge" style={{ background: '#fef3c7', color: '#f59e0b' }}>Draft</span>
                    </div>
                    <div className="dash-stat-number">{data?.unpublish ?? 0}</div>
                    <div className="dash-stat-label">Unpublished</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/my-inventory" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Offers Table + Account Card */}
              <div className="row g-3 mb-4">
                <div className="col-12 col-lg-8">
                  <div className="cl-card h-100 d-flex flex-column">
                    <div className="cl-card-header">
                      <span className="fw-bold">New Offers</span>
                      {data?.pending_bidding_count > 0 && (
                        <span className="cl-badge-teal">{data.pending_bidding_count}</span>
                      )}
                    </div>
                    <div className="cl-card-body p-0 flex-grow-1">
                      <div className="table-responsive">
                        <table className="table dash-offers-table mb-0">
                          <thead>
                            <tr>
                              <th>Car</th>
                              <th>Buyer</th>
                              <th>Price</th>
                              <th className="d-none d-md-table-cell">Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.biddings?.length > 0 ? (
                              data.biddings.map((bid, i) => (
                                <tr key={i}>
                                  <td>{bid?.name}</td>
                                  <td>{bid?.bidder_name}</td>
                                  <td><strong>&pound;{formatNumber(bid?.bidder_price)}</strong></td>
                                  <td className="d-none d-md-table-cell text-muted">{bid?.created_at}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center text-muted py-4">
                                  <i className="fa-solid fa-inbox fs-4 d-block mb-2 opacity-25"></i>
                                  No new offers yet
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="cl-card-footer d-flex justify-content-end">
                      <Link to="/dealer/all-offers" className="cl-btn cl-btn-primary cl-btn-sm">
                        View All Offers
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="cl-card h-100">
                    <div className="cl-card-header"><span className="fw-bold">My Account</span></div>
                    <div className="cl-card-body text-center">
                      <img
                        src={
                          storedUserPreferences?.profile &&
                            storedUserPreferences.profile !== "null"
                            ? `${baseUrl}${storedUserPreferences.profile}`
                            : "img/user_default.png"
                        }
                        alt={dealerName}
                        className="dash-avatar"
                      />
                      <p className="dash-account-name">{dealerName}</p>
                      <p className="dash-account-email">{storedUserPreferences?.email}</p>

                      <div className="dash-info-row">
                        <span className="dash-info-label">Plan</span>
                        <span className="dash-plan-badge">
                          {storedUserPreferences?.dealer_plan?.plan_code
                            ?.split("_")
                            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                            .join(" ")}
                        </span>
                      </div>
                      <div className="dash-info-row">
                        <span className="dash-info-label">Expires</span>
                        <span className="dash-info-value">{storedUserPreferences?.dealer_plan?.expired_at}</span>
                      </div>
                      <div className="dash-info-row">
                        <span className="dash-info-label">Car Limit</span>
                        <span className="dash-info-value">
                          {storedUserPreferences?.dealer_plan?.car_limit == 1000
                            ? "Unlimited"
                            : storedUserPreferences?.dealer_plan?.car_limit}
                        </span>
                      </div>

                      <div className="d-flex flex-wrap gap-2 justify-content-center mt-3">
                        <Link to="/edit/dealer/profile" className="cl-btn cl-btn-primary cl-btn-sm">Edit Profile</Link>
                        <Link to="/dealer/plans" className="cl-btn cl-btn-outline cl-btn-sm">Change Plan</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== BUYING ===== */}
              <div className="dash-section-label">
                <i className="fa-solid fa-shopping-bag"></i>Buying
              </div>
              <div className="row g-3 mb-4">
                {/* Unlocked */}
                <div className="col-6 col-sm-6 col-md-3">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#d1fae5', color: '#10b981' }}>
                        <i className="fa fa-lock-open"></i>
                      </div>
                    </div>
                    <div className="dash-stat-number">{data?.accept ?? 0}</div>
                    <div className="dash-stat-label">Unlocked Cars</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/unlocked-cars" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>

                {/* Pending */}
                <div className="col-6 col-sm-6 col-md-3">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#fef3c7', color: '#f59e0b' }}>
                        <i className="fa fa-clock"></i>
                      </div>
                      {data?.pending > 0 && (
                        <span className="dash-stat-badge" style={{ background: '#fef3c7', color: '#f59e0b' }}>{data.pending}</span>
                      )}
                    </div>
                    <div className="dash-stat-number">{data?.pending ?? 0}</div>
                    <div className="dash-stat-label">Pending Offers</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/pending-unlocks" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>

                {/* Denied */}
                <div className="col-6 col-sm-6 col-md-3">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#fde8e8', color: '#ef4444' }}>
                        <i className="fa-solid fa-ban"></i>
                      </div>
                    </div>
                    <div className="dash-stat-number">{data?.reject ?? 0}</div>
                    <div className="dash-stat-label">Denied Offers</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/decline-offers" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>

                {/* Favourites */}
                <div className="col-6 col-sm-6 col-md-3">
                  <div className="dash-stat">
                    <div className="dash-stat-row">
                      <div className="dash-stat-icon" style={{ background: '#fce7f3', color: '#ec4899' }}>
                        <i className="fa-regular fa-heart"></i>
                      </div>
                    </div>
                    <div className="dash-stat-number">{data?.favourite ?? 0}</div>
                    <div className="dash-stat-label">Favourites</div>
                    <div className="dash-stat-action">
                      <Link to="/dealer/favourites-car" className="cl-btn cl-btn-outline cl-btn-sm w-100 text-center">View All</Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== CREDITS ===== */}
              <div className="dash-section-label">
                <i className="fa-solid fa-coins"></i>Credits
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-4 col-lg-3">
                  <div className="dash-credits-card">
                    <div>
                      <div className="dash-credits-label">Current Balance</div>
                      <div className="dash-credits-amount">{myCeredit}</div>
                      <div className="dash-credits-unit">credits available</div>
                    </div>
                    <Link to="/buyplan" className="dash-btn-white-bordered">
                      <i className="fa-solid fa-plus me-1"></i>Get More Credits
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-8 col-lg-9">
                  <div className="cl-card h-100">
                    <div className="cl-card-header"><span className="fw-bold">Credit History</span></div>
                    <div className="cl-card-body">
                      <ReactApexChart
                        options={state.options}
                        series={state.series}
                        type="area"
                        height={220}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MyDashboard;
